<template>
  <div>
    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div v-if="!cartoes.length">
        <div class="text-center mt-5">
          <div class="mb-4">
            <icon name="card" class="text-primary" size="48"></icon>
          </div>
          <p>Você ainda não tem nenhum cartão de crédito cadastrado</p>
        </div>
      </div>
      <div v-else>
        <h6 class="text-center mt-4 mb-3" v-if="pedido">Selecione um cartão</h6>
        <div class="mb-3" v-for="(e, index) in cartoes" :key="index">
          <a href="javascript:" class="card card-border text-dark" @click="selecionarCartao(e);">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="mr-3">
                  <img v-if="e.payment_method && e.payment_method.thumbnail" :src="e.payment_method.thumbnail" :alt="e.payment_method.name" style="width: 32px">
                  <icon v-else name="card" size="32"></icon>
                </div>
                <div class="small">
                  Cartão de Crédito
                  <div class="small" v-if="e.payment_method">{{e.payment_method.name}}</div>
                  <div class="font-weight-bold">**** **** **** {{ e.last_four_digits }}</div>
                </div>
                <div class="ml-auto text-right">
                  <button class="btn text-danger" @click.stop="deletarCartao(e)" title="Remover">
                    <i class="fa fa-trash-o"></i>
                  </button>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div v-if="pedido">
        <hr>
        <button class="btn btn-outline-primary btn-block" @click="cadastrarCartao">Adicionar novo cartão</button>
      </div>
    </div>

    <modal ref="modalCartao" @voltar="fecharModalCartao(true)" :title="'Dados do Cartão'" :overflow="true">
      <form @submit.prevent="processarCVV" v-if="menu === 2">
        <div class="container container-endereco">
          <aviso-informativo variante="cinza" :mostrar-icone="false" class="my-4" v-if="cartao">Por favor informe o código de segurança do seu cartão final {{ cartao.last_four_digits }}.</aviso-informativo>
          <aviso-informativo variante="vermelho" :mostrar-icone="false" v-if="mensagensErroCartao.length" class="my-3" role="alert">
            <div v-for="(mensagem, index) in mensagensErroCartao" :key="'erro-cvv-' + index">
              {{ mensagem }}
            </div>
          </aviso-informativo>
          <div class="mb-3">
            <div id="form-checkout__securityCode-container" class="form-control"></div>
            <label class="small mb-1">Código de segurança (CVV)</label>
            <input name="token" id="token" hidden>
            <div class="small text-danger font-weight-bold ml-1" :class="{'invisible': erroMsg !== 3}">Código de segurança inválido</div>
          </div>
        </div>
        <div class="border-top btn-avancar fixed-container">
          <div class="p-3">
            <button type="submit" class="btn btn-primary btn-block btn-bottom" :disabled="loadCartao">
              <span v-if="loadCartao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-else>Confirmar pagamento</span>
            </button>
          </div>
        </div>
      </form>
      <form id="form-checkout" v-if="menu === 1">
        <div id="containerPagamento" class="container container-endereco">
          <div class="mt-3">
            <aviso-informativo variante="vermelho" :mostrar-icone="false" v-if="mensagensErroCartao.length" class="mb-3" role="alert">
              <div v-for="(mensagem, index) in mensagensErroCartao" :key="'erro-cartao-' + index">
                {{ mensagem }}
              </div>
            </aviso-informativo>
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Número do cartão*</label>
              <div id="form-checkout__cardNumber" class="form-control"></div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Data de validade (Mês/Ano)*</label>
                  <div id="form-checkout__expirationDate" class="form-control"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Código de segurança (CVV)*</label>
                  <div id="form-checkout__securityCode" class="form-control"></div>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Nome do titular*</label>
              <input type="text" id="form-checkout__cardholderName" class="form-control" required/>
            </div>
            <div class="row">
              <div class="col-sm-6 d-none">
                <div class="form-group mb-2">
                  <select id="form-checkout__issuer" class="form-control"></select>
                </div>
              </div>
              <div class="col-sm-6 d-none">
                <div class="form-group mb-2">
                  <select id="form-checkout__installments" class="form-control"></select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Tipo de identificação*</label>
                  <select id="form-checkout__identificationType" class="form-control"></select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">CPF/CNPJ do Titular*</label>
                  <input type="tel" id="form-checkout__identificationNumber" class="form-control" minlength="11" maxlength="14" v-model="cpfNumber" @blur="validarCPF" required/>
                </div>
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="mb-0 font-weight-bold small">E-mail*</label>
              <input type="email" id="form-checkout__cardholderEmail" class="form-control" required/>
            </div>
          </div>
        </div>
        <div class="fixed-bottom bg-white border-top btn-avancar fixed-container">
          <div class="p-3">
            <button type="submit" id="form-checkout__submit" class="btn btn-primary btn-block btn-bottom" :disabled="loadCartao">
              <span v-if="loadCartao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-else>Salvar cartão</span>
            </button>
          </div>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import AvisoInformativo from "./AvisoInformativo";
import { loadMercadoPago } from "@mercadopago/sdk-js";
import Loading from "../components/Loading";
import Icon from "../components/Icon";
import Modal from "../components/Modal";
import {TheMask} from 'vue-the-mask';

export default {
  name: 'CartoesMercadopago',
  components: {AvisoInformativo, Loading, Icon, Modal, TheMask},
  props: ['pedido', 'dados'],
  data() {
    return {
      token: localStorage.getItem('token'),
      load: true,
      cartoes: [],
      loadCartao: false,
      mp: null,
      cardForm: null,
      securityCodeElement: null,
      erroMsg: null,
      mensagensErroCartao: [],
      menu: 1,
      cartao: null,
      cpfNumber: ''
    }
  },

  methods: {
    selecionarCartao(cartao) {
      if (!this.pedido) {
        return;
      }

      this.limparErroCartao();
      this.cartao = {
        id: cartao.id,
        paymentMethodId: cartao.payment_method.id,
        issuerId: cartao.issuer.id,
        customer_id: cartao.customer_id,
        installments: 1
      };

      this.menu = 2;
      this.$nextTick(() => {
        this.instanciarFormMp();
        this.$emit('openModal');
      });
    },

    async processarCVV() {
      if (this.loadCartao) {
        return;
      }

      this.limparErroCartao();
      this.loadCartao = true;

      try {
        const token = await this.mp.fields.createCardToken({ cardId: this.cartao.id });
        this.cartao.token = token.id;
        this.cartao.saveCartao = 0;
        this.processarPagamento();

      } catch (e) {
        this.loadCartao = false;
        this.definirErroCartao(this.getMensagemErroApi(e) || "Não conseguimos processar seu pagamento.");
        this.$swal("Não conseguimos processar seu pagamento." + (e ? "\nErro: " + e : ""));
      }
    },

    processarPagamento() {
      this.limparErroCartao();
      this.loadCartao = true;
      this.$store.state.load = "Processando pagamento";

      this.$http.post(this.pedido.token + '/' + this.token + '/pix-mercado-pago', { ...this.dados, cartao: this.cartao })
        .then(response => {
          this.loadCartao = false;
          this.$store.state.load = false;

          if (response.data && response.data.result && response.data.status === 'approved') {
            this.fecharModalCartao();
            this.$emit('atualizar', true);

          } else {
            this.definirErroCartao(
              this.getMensagemErroPagamento(response.data) ||
              "Não conseguimos processar seu pagamento. Verifique o código de segurança ou tente com outro cartão."
            );
            this.$swal("Não conseguimos processar seu pagamento. Verifique o código de segurança ou tente com outro cartão.");
          }

        }, res => {
          this.loadCartao = false;
          this.$store.state.load = false;
          const msg = res.data ? res.data.msg : null;
          const mensagemErro = this.getMensagemErroPagamento(res.data) || msg || "Não conseguimos processar seu pagamento.";
          this.definirErroCartao(mensagemErro);
          this.$swal("Não conseguimos processar seu pagamento." + (msg ? "\nErro: " + msg : ""));

          if (res.data.status === 'rejected') {
            this.clearForms();

            setTimeout(() => {
              this.definirErroCartao(mensagemErro);
              this.instanciarFormMp();
            }, 2000);
          }
        });
    },

    fecharModalCartao(clear) {
      this.$emit('closeModal');

      if (clear) {
        this.clearForms();
      }
    },

    clearForms() {
      this.erroMsg = null;
      this.mensagensErroCartao = [];
      this.loadCartao = false;
      this.cpfNumber = '';
      this.cartao = null;

      if (this.cardForm) {
        this.cardForm.unmount();
        this.cardForm = null;
      }

      if (this.securityCodeElement) {
        this.securityCodeElement.unmount();
        this.securityCodeElement = null;
      }
    },

    buscarCartoes(callback) {
      this.load = true;
      this.$http.get(this.$store.state.base_url + this.token + '/cartao/buscar?plataforma=1')
        .then(response => {
          this.load = false;

          if (response.data) {
            this.cartoes = response.data || [];

            if (this.pedido && !this.cartoes.length) {
              this.cadastrarCartao();
              return;
            }

            if (callback) {
              callback();
            }
          }

        }, res => {
          this.load = false;
          let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg);
        });
    },

    deletarCartao(cartao) {
      this.$swal({
        text: 'Deseja realmente deletar o cartão?',
        buttons: ["Não", "Sim"],
        dangerMode: true
      }).then((res) => {
        if (res) {
          this.load = true;
          cartao.plataforma = 1;
          this.$http.post(this.$store.state.base_url + this.token + '/cartao/deletar', cartao).then(response => {
            this.load = false;

            if (response.data && response.data.success) {
              this.$swal("Cartão deletado com sucesso!");
              this.cartoes = this.cartoes.filter(c => c.id !== cartao.id);
            }

          }, res => {
            let msg = res.data && res.data.response ? res.data.response : 'Erro temporário';
            this.$swal(msg);
            this.load = false;
          });
        }
      });
    },

    cadastrarCartao() {
      this.menu = 1;
      this.limparErroCartao();
      this.$nextTick(() => {
        this.instanciarFormMp();
        this.$emit('openModal');
      })
    },

    instanciarFormMp() {
      if (!this.mp) {
        return;
      }

      if (this.menu === 2) {
        if (this.securityCodeElement) {
          return;
        }

        this.securityCodeElement = this.mp.fields.create('securityCode', { placeholder: "CVV" });
        this.securityCodeElement.mount('form-checkout__securityCode-container')
        return;
      }

      if (this.cardForm) {
        return;
      }

      const form = {
        id: "form-checkout",
        cardNumber: {
          id: "form-checkout__cardNumber",
          placeholder: "Número do cartão"
        },
        expirationDate: {
          id: "form-checkout__expirationDate",
          placeholder: "MM/AA (Ex 10/29)",
        },
        securityCode: {
          id: "form-checkout__securityCode",
          placeholder: "Código de segurança",
        },
        cardholderName: {
          id: "form-checkout__cardholderName",
          placeholder: "Titular do cartão",
        },
        issuer: {
          id: "form-checkout__issuer",
          placeholder: "Banco emissor",
        },
        installments: {
          id: "form-checkout__installments",
          placeholder: "Parcelas",
        },
        identificationType: {
          id: "form-checkout__identificationType",
          placeholder: "Tipo de documento",
        },
        identificationNumber: {
          id: "form-checkout__identificationNumber",
          placeholder: "Número do documento",
        },
        cardholderEmail: {
          id: "form-checkout__cardholderEmail",
          placeholder: "E-mail",
        },
      }

      this.cardForm = this.mp.cardForm({
        amount: this.pedido ? this.pedido.valor_total : "0.5",
        autoMount: false,
        iframe: true,
        form,

        callbacks: {
          onFormMounted: error => {
            if (error) return console.warn("Form Mounted handling error: ", error);
            console.log("Form mounted");
          },

          onCardTokenReceived: (errorData, token) => {
            if (errorData || !token) {
              if (errorData && errorData.length) {
                this.validarMsgCartao(errorData);
              } else {
                this.definirErroCartao('Não foi possível validar os dados do cartão. Confira as informações e tente novamente.');
                this.$swal('Não foi possível validar os dados do cartão. Confira as informações e tente novamente.');
              }
              this.loadCartao = false;
              return null;
            }

            return token;
          },

          onSubmit: event => {
            this.limparErroCartao();
            this.loadCartao = true;
            event.preventDefault();
            const data = this.cardForm.getCardFormData();

            if (!data || !data.token) {
              this.loadCartao = false;
              this.definirErroCartao('Token do cartão não gerado. Confira os dados informados e tente novamente.');
              this.$swal('Token do cartão não gerado.');
              this.$emit('scrollTop');

              return;
            }

            data.plataforma = 1;

            if (this.pedido) {
              data.saveCartao = 1;
              this.loadCartao = true;
              this.cartao = data;
              this.processarPagamento();

            } else {
              this.salvarCartao(data);
            }
          },

          onFetching: (resource) => {
            if (resource === 'cardToken') {
              this.loadCartao = true;
            }

            return () => {}
          }
        },
      });

      this.cardForm.mount();
    },

    salvarCartao(data) {
      this.limparErroCartao();
      this.loadCartao = true;

      this.$http.post(this.$store.state.base_url + this.token + '/cartao/criar', data)
        .then(() => {
          this.loadCartao = false;
          this.buscarCartoes();
          this.fecharModalCartao(true);
          this.$swal("Cartão criado com sucesso!");
        })
        .catch((res) => {
          this.loadCartao = false;
          this.definirErroCartao(res.data?.msg || 'Erro ao salvar cartão');
          this.$swal(res.data?.msg || 'Erro ao salvar cartão');
        });
    },

    iniciarMP() {
      loadMercadoPago().then(() => {
        if (this.empresa.mp_public_key) {
          this.mp = new window.MercadoPago(this.empresa.mp_public_key);
        }
      })
    },

    validarMsgCartao(errorData) {
      this.erroMsg = null;
      const mensagens = (errorData || [])
        .map(item => this.getErrorMsgByMercadoPagoError(item))
        .filter(Boolean);

      if (mensagens.length) {
        const mensagensUnicas = [...new Set(mensagens)];
        this.erroMsg = this.getCodigoErroCartao(errorData[0]);
        this.definirErroCartao(mensagensUnicas);
        this.$swal(mensagensUnicas.join('\n'));
      }
    },

    limparErroCartao() {
      this.erroMsg = null;
      this.mensagensErroCartao = [];
    },

    definirErroCartao(mensagem) {
      if (Array.isArray(mensagem)) {
        this.mensagensErroCartao = mensagem.length ? mensagem : ['Confira os dados do cartão'];
      } else {
        this.mensagensErroCartao = [mensagem || 'Confira os dados do cartão'];
      }
      this.$emit('scrollTop');
    },

    getMensagemErroApi(error) {
      if (!error) {
        return null;
      }

      if (typeof error === 'string') {
        return error;
      }

      return error.message || error.cause?.[0]?.description || null;
    },

    getMensagemErroPagamento(data) {
      if (!data) {
        return null;
      }

      return data.msg || data.message || data.response || data.status_detail || null;
    },

    getCodigoErroCartao(errorItem) {
      const error = errorItem ? (errorItem.field || errorItem.code) : null;

      switch (error) {
        case "cardNumber":
        case '205':
        case 'E301':
          return 1;
        case "expirationDate":
        case '208':
        case '224':
        case '325':
        case '326':
        case 'E203':
          return 2;
        case "securityCode":
          return 3;
        case 'cardholderName':
        case '221':
        case '316':
          return 4;
        case 'identificationNumber':
        case '214':
        case '324':
          return 5;
        case 'cardholderEmail':
          return 6;
        default:
          return 99;
      }
    },

    getErrorMsgByMercadoPagoError(errorItem) {
      return this.getErrorMsg(this.getCodigoErroCartao(errorItem));
    },

    getErrorMsg(e) {
      switch (e) {
        case 1:
          return 'Informe um número de cartão válido';
        case 2:
          return 'Data de expiração inválida';
        case 3:
          return 'Código de segurança inválido';
        case 4:
          return 'Nome do titular inválido';
        case 5:
          return 'CPF / CNPJ inválido';
        case 6:
          return 'Email inválido';
        default:
          return 'Confira os dados do cartão';
      }
    },

    validarCPF() {
      this.cpfNumber = this.cpfNumber.replace(/[^0-9]+/g, "");
    }
  },

  created() {
    document.body.classList.remove("modal-open");
  },

  mounted() {
    this.url = this.$helpers.getUrlApp(this.$route.params.id || '');

    if (this.token) {
      window.scrollTo(0, 0);
      this.iniciarMP();
      this.buscarCartoes();
    }
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    }
  },

  beforeDestroy() {
    if (this.cardForm) {
      this.cardForm.unmount();
    }

    if (this.securityCodeElement) {
      this.securityCodeElement.unmount();
    }
  }
}
</script>

<style scoped>
.btn-avancar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background-color: #fff;
}

.container-endereco {
  padding-bottom: 80px;
}

@media (min-width: 768px) {
  .btn-avancar {
    position: static;
    padding-right: 15px;
    padding-left: 15px;
  }

  .container-endereco {
    overflow: auto;
    height: calc(80vh - 142px);
    padding-bottom: 0;
  }
}
</style>
